import styled from 'styled-components';

export const ManageGeneSetsGridWrapper = styled.div`
    height: 400px;
    cursor: pointer;
`;
